exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invalid-tip {\n  pointer-events: none;\n  color: #ebafa6 !important;\n  position: absolute !important;\n  top: 0;\n  padding-left: 6px;\n  font-size: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/shifts-recon/components/form-shorts-overs-recon/field/form-shorts-overs-field.component.scss
// module id = ../../../../../src/app/views/daily-recon/shifts-recon/components/form-shorts-overs-recon/field/form-shorts-overs-field.component.scss
// module chunks = main